import axios from "axios";

const marketApi = axios.create({
  baseURL: process.env.REACT_APP_MARKET_API_BASE || "/market-api",
});

// Industry Groups (top-level)
export const fetchIndustryGroups = async () => {
  const res = await marketApi.get("/industries/domain/IndustryGroup/");
  return res.data;
};

// Industry by ID
export const fetchIndustryById = async (id) => {
  const res = await marketApi.get(`/industries/id/${id}`);
  return res.data;
};

// Child industries by parent ID
export const fetchIndustriesByParent = async (parentId) => {
  const res = await marketApi.get(`/industries/parent/${parentId}`);
  return res.data;
};

// Roles
export const fetchRoles = async () => {
  const res = await marketApi.get("/roles/");
  return res.data;
};

// Functions by roles
export const fetchFunctionsByRoles = async (roles) => {
  const res = await marketApi.post("/functions/roles/", roles);
  return res.data;
};

// Services (市場サービス区分)
export const fetchMarketServices = async () => {
  const res = await marketApi.get("/services/");
  return res.data;
};

// Goods (市場商品区分)
export const fetchMarketGoods = async () => {
  const res = await marketApi.get("/goods/");
  return res.data;
};

// Goal Classes by goalType ID
export const fetchGoalClassesByGoalType = async (goalTypeId) => {
  const res = await marketApi.get(`/goalType/goalClass/${goalTypeId}`);
  return res.data;
};

// Goal Types by goalCategory ID
export const fetchGoalTypesByGoalCategory = async (goalCategoryId) => {
  const res = await marketApi.get(`/goalCategory/goalType/${goalCategoryId}`);
  return res.data;
};

// Goal Details by goalClass ID
export const fetchGoalDetailsByGoalClass = async (goalClassId) => {
  const res = await marketApi.get(`/goalClass/goalDetail/${goalClassId}`);
  return res.data;
};
